import React from 'react';
import { Wrench, PackageOpen, Truck, Hammer, Tv, Smartphone, Users } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';

const ServicesSection = () => {
  const services = [
    {
      icon: <Wrench className="w-8 h-8" />,
      title: 'Home repairs & maintenance'
    },
    {
      icon: <PackageOpen className="w-8 h-8" />,
      title: 'Furniture assembly & disassembly'
    },
    {
      icon: <Truck className="w-8 h-8" />,
      title: 'Moving help & heavy lifting'
    },
    {
      icon: <Hammer className="w-8 h-8" />,
      title: 'Fixture & hardware installation'
    },
    {
      icon: <Tv className="w-8 h-8" />,
      title: 'TV mounting & wall hangings'
    },
    {
      icon: <Smartphone className="w-8 h-8" />,
      title: 'Smart home installs'
    },
    {
      icon: <Users className="w-8 h-8" />,
      title: 'General labor & extra-hand jobs'
    }
  ];

  return (
    <section className="py-20 bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16 scroll-animate">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            What We <span className="text-red-500">Handle</span>
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            If it needs to be fixed, moved, assembled, installed, or handled safely — we've got you covered.
          </p>
        </div>

        {/* Services Grid */}
        <div className="mb-12">
          <h3 className="text-2xl font-bold mb-8 scroll-animate" style={{ color: '#FFD700' }}>
            Popular Services
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {services.map((service, index) => (
              <Card 
                key={index}
                className="scroll-animate bg-black/50 border-red-900/30 hover:border-red-500 transition-all duration-300 transform hover:scale-105 cursor-pointer"
              >
                <CardContent className="p-6 flex items-center space-x-4">
                  <div className="text-red-500">
                    {service.icon}
                  </div>
                  <p className="text-white font-medium">
                    {service.title}
                  </p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>

        {/* Additional Info */}
        <div className="text-center scroll-animate">
          <p className="text-gray-400 mb-6 text-lg">
            If a specific service isn't listed, that doesn't mean we don't offer it. <br />
            Send the details and we'll tell you the best next step.
          </p>
          <Button 
            className="bg-red-600 hover:bg-red-700 text-white font-semibold px-8 py-6 text-lg transition-all duration-300 shadow-lg shadow-red-600/50"
            onClick={() => window.location.href = '/services'}
          >
            View All Services
          </Button>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
